const BASE_URL = '/api/v1/precision-meeting';

const DEFAULT_ERROR_MESSAGE =
  'The brief could not be prepared. Please try again.';

// A 4xx answer says why the brief can't be prepared. Anything else is a failure worth retrying.
const getError = async response => {
  const data = await response.json().catch(() => ({}));
  const isClientError = response.status >= 400 && response.status < 500;
  return new Error((isClientError && data.error) || DEFAULT_ERROR_MESSAGE);
};

const toQuery = target => new URLSearchParams(target).toString();

// Without a target: is it on for the user's client. With { callRecordingId } or { apptId }: can this call be used.
export const getPrecisionMeetingStatus = async (target = {}) => {
  const query = toQuery(target);
  const response = await fetch(`${BASE_URL}/status${query && `?${query}`}`);
  if (response.status !== 200) throw new Error();

  return response.json();
};

export const getPrecisionMeetingBrief = async (target, signal) => {
  const response = await fetch(`${BASE_URL}?${toQuery(target)}`, { signal });
  if (response.status !== 200) throw await getError(response);

  return response.json();
};

export const generatePrecisionMeetingBrief = async (target, signal) => {
  const response = await fetch(BASE_URL, {
    signal,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(target),
  });
  if (response.status !== 200) throw await getError(response);

  return response.json();
};
